import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import 'antd/dist/reset.css';
import { HelmetProvider } from 'react-helmet-async';
import Signin from './Pages/account/signin';
import AdminLayout from './Layouts/AdminLayout';
import Dashboard from './Pages/admin/dashboard';
import Applications from './Pages/admin/applications';
import FormularioPage from './Pages/formulario/page';


const router = createBrowserRouter([
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { path: '/admin', element: <Dashboard /> },
      { path: '/admin/applications', element: <Applications /> },
      { path: '/admin/document/:id', element: <FormularioPage /> },
    ]
  },
  {
    path: '/signin',
    element: <Signin />
  },
]);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
